import type { HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type { EnvironmentImportApi } from '@env0/environment-import-service/api';

export default (client: HttpClient) => ({
  findDiscoveredEnvironments: async (
    environmentDiscoveryConfigId: string
  ): Promise<EnvironmentImportApi.FindDiscoveredEnvironments.Response> =>
    client
      .get(`environment-import/discovered`, {
        params: { environmentDiscoveryConfigId }
      })
      .then(returnData),

  discoverEnvironments: async (environmentDiscoveryConfigId: string): Promise<void> =>
    client
      .post('environment-import/discover', null, {
        params: { environmentDiscoveryConfigId }
      })
      .then(returnData),

  importEnvironments: async (
    body: EnvironmentImportApi.BatchImport.Request.Body
  ): Promise<EnvironmentImportApi.BatchImport.Response> =>
    client.post('environment-import/batch', body).then(returnData),

  rerunImportEnvironments: async (
    body: EnvironmentImportApi.BatchImport.Request.Body
  ): Promise<EnvironmentImportApi.BatchImport.Response> =>
    client.post('environment-import/rerun', body).then(returnData),

  getActiveSession: async (organizationId: string): Promise<EnvironmentImportApi.GetActiveSession.Response> =>
    client
      .get('environment-import/source/sessions/active', {
        params: { organizationId },
        hideNotification: true
      })
      .then(returnData),

  connect: async (body: EnvironmentImportApi.Connect.Request.Body): Promise<EnvironmentImportApi.Connect.Response> =>
    client.post('environment-import/source/connect', body).then(returnData),

  triggerScan: async (sessionId: string): Promise<EnvironmentImportApi.TriggerSourceScan.Response> =>
    client.post(`environment-import/source/sessions/${sessionId}/scan`, {}).then(returnData),

  getSelectionIssues: async (
    sessionId: string,
    workspaceIds: string
  ): Promise<EnvironmentImportApi.GetSelectionIssues.Response> =>
    client
      .get(`environment-import/source/sessions/${sessionId}/issues`, {
        params: { workspaceIds }
      })
      .then(returnData),

  updateWorkspaceSecrets: async (
    sessionId: string,
    workspaceId: string,
    body: EnvironmentImportApi.UpdateWorkspaceSecrets.Request.Body
  ): Promise<EnvironmentImportApi.UpdateWorkspaceSecrets.Response> =>
    client
      .patch(`environment-import/source/sessions/${sessionId}/workspaces/${workspaceId}/secrets`, body)
      .then(returnData),

  updateVariableSetSecrets: async (
    sessionId: string,
    variableSetId: string,
    body: EnvironmentImportApi.UpdateVariableSetSecrets.Request.Body
  ): Promise<EnvironmentImportApi.UpdateVariableSetSecrets.Response> =>
    client
      .patch(`environment-import/source/sessions/${sessionId}/variable-sets/${variableSetId}/secrets`, body)
      .then(returnData),

  getInventory: async (
    sessionId: string,
    params?: { page?: string; limit?: string; nameFilter?: string; status?: EnvironmentImportApi.InventoryStatusFilter }
  ): Promise<EnvironmentImportApi.GetInventory.Response> =>
    client.get(`environment-import/source/sessions/${sessionId}/inventory`, { params }).then(returnData),

  getMigrationResults: async (sessionId: string): Promise<EnvironmentImportApi.GetMigrationResults.Response> =>
    client.get(`environment-import/source/sessions/${sessionId}/results`).then(returnData),

  goLive: async (
    sessionId: string,
    body: EnvironmentImportApi.GoLive.Request.Body
  ): Promise<EnvironmentImportApi.GoLive.Response> =>
    client.post(`environment-import/source/sessions/${sessionId}/go-live`, body).then(returnData)
});
